import { Component, ViewChild, Input, Inject, AfterViewInit, OnInit, EventEmitter, DOCUMENT } from '@angular/core';
import { environment } from '../../../environments/environment';

import { GenericService } from '../../../common/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../../../common/data.service';
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LazyLoadingService } from '../../../common/lazyloading';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { ScoreCardGroupScoreAnalysis, APIParamSA, QualitativeWeightedScoreResponse, FinancialIndexWithScore, FinancialIndexWithRating } from '../ScoreAnalysis/ScoreAnalysis.model'
import { FAScoringModelFinancialView, APIParam, QuantitativeGroup } from '../WFScoringQuantitativeDetail/WFScoringQuantitativeDetail.model'
import { FAScoringModelQualitativeView } from '../WFScoringQualitativeDetail/WFScoringQualitativeDetail.model'
import { FAScoringModelFinalScoreView } from '../FinalScoreAnalysis/FinalScoreAnalysis.model'
import { JSONCurrentInstanceData } from '../../WorkflowDashBoard.model';
import { UtilityService } from '../../../common/utility.service';



@Component({
    selector: 'app-FinalScoreAnalysis-Component',
    templateUrl: './FinalScoreAnalysis.component.html',
    styleUrls: ['./FinalScoreAnalysis.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})
///Component can be integrated with parent component 
export class FinalScoreAnalysis implements OnInit {



  public documentURL: string;
  public urlAarray: string[];
  public baseURL: string;
  public hostname: string;
  public __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public userName: string;
  public __oInstanceAllStateData: JSONCurrentInstanceData[] = [];
  public __sScoringModelName: string = '';
  public __oQuantitativeGroup: QuantitativeGroup[] = [];
  public __oQuantitativeScoreCardGroup: QuantitativeGroup[] = [];
  public __oQuantitativeView: string = 'Score Card Group';
  public __oQuantitativeViews: any[];
  public __sQuantitativeValue: string = null;
  public __sQualitativeValue: string = null;
  public __sScoreAnalysisValue: string = null;
  public __iTotalWeightGauge: number = 0;

  public __sWeightedFinancialRating: string = '';
  public __iWeightedFinancialScore: number;

  public __sWeightedQualitativeRating: string = '';
  public __iWeightedQualitativeScore: number;

  public __sWeightedIntrinsicRating: string = '';
  public __iWeightedIntrinsicScore: number;

  public __bIsLoadingVisible: boolean = false;
  public __oFroalaEditorOptions: Object = {};
  public __oFroalaEditorOptionReadOnly: Object = {};

  public __sCountryCapRating: string = '';
  public __sGroupCapRating: string = '';
  public __sFinalRating: string = '';
  public __sActualFinalRating: string = '';
  public __iRecommendedCreditLimit: number;
  public __iActualCreditLimit: number;
  public __sComments: any;

  public __oRatings: any[] = [];
  public __sBaseCurrency: string = '';

  public __oFAScoringModelFinalScoreView: FAScoringModelFinalScoreView[] = [];

  onInitialized = new EventEmitter<FinalScoreAnalysis>();

  @Input()
  __sInstanceId: number = 0;

  @Input()
  __sStateDataId: number = 0;

  @Input()
  __sValue: any = "";

  @Input()
  __sDataCaption: string = "";

  @Input()
  __sQuantitativeControlState: string = "";

  @Input()
  __sScoringModel: string = "";

  @Input()
  __sBasePeriod: string = "";

  @Input()
  __sPeriod: string = "";

  @Input()
  __sTradingCounterparty: string = "";

  @Input()
  __sQuantitativeControl: string = "";

  @Input()
  __sQualitativeControl: string = "";

  @Input()
  __sScoreAnalysisControl: string = "";

  @Input()
  __bReadOnly: number = 0;

  @Input()
  __sFinalScoreControl: string = "";
  



  public __oFAScoringModelFinancialView: FAScoringModelFinancialView[] = [];
  public __oFAScoringModelQualitativeView: FAScoringModelQualitativeView[] = [];
  public __oFAScoreCardGroupScoreAnalysis: ScoreCardGroupScoreAnalysis[] = [];

  constructor(@Inject(DOCUMENT) public document: any, public service: GenericService, public route: ActivatedRoute, public router: Router, public data: DataService, public __oUtilityService: UtilityService, public http: HttpClient, public datePipe: DatePipe, public lazyLoadingService: LazyLoadingService) {
    let sViews: any[] = [
      {
        id: 0,
        text: "Score Card Group"
      },
      {
        id: 1,
        text: "Financial Group"
      }
    ];

    this.__oQuantitativeViews = sViews;
    this.service.getDataByObservable(this.__sGetApiUrl + "api/CommonBase/FroalaKey").subscribe((data) => {
      if (data != null) {
        this.__oFroalaEditorOptions = {
          key: data,
          attribution: false,
          heightMin: 250,
          heightMax: 500,
          width: 800,
          charCounterMax: 20000,
          charCounterCount: false,
          tableResizer: true,
          imageResize: true,
          useClasses: false,
          placeholderText: 'Enter Details ...',
          // Set the image upload parameter.
          imageUploadParam: 'image_param',

          // Set the image upload URL.
          imageUploadURL: 'assets/upload_image',

          // Additional upload params.
          imageUploadParams: { id: 'my_editor' },

          // Set request type.
          imageUploadMethod: 'POST',

          // Set max image size to 5MB.
          imageMaxSize: 5 * 1024 * 1024,

          // Allow to upload PNG and JPG.
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
          toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'textColor', 'backgroundColor', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'undo', 'redo'],
          //toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertFile', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'help', 'html', '|', 'undo', 'redo'],
          colorsBackground: [
            '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
            '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
          ],
          colorsStep: 6,
          colorsText: [
            '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
            '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
          ],
          pluginsEnabled: ['align', 'colors', 'draggable', 'fontFamily', 'fontSize', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'print', 'quote', 'image', 'table', 'specialCharacters', 'url', 'wordPaste'],
          events: {
            'froalaEditor.initialized': function (e: any, editor: any) {

            },
            'froalaEditor.image.beforeUpload': (e: any, editor: any, images: any) => {
              //Your code 
              if (images.length) {
                // Create a File Reader.
                const reader = new FileReader();
                // Set the reader to insert images when they are loaded.
                reader.onload = (ev) => {
                  const result = ev.target['result'];
                  editor.image.insert(result, null, null, editor.image.get());
                };
                // Read image as base64.
                reader.readAsDataURL(images[0]);
              }
              // Stop default upload chain.
              return false;
            },
            'froalaEditor.mousedown': (e, editor, mousedownEvent) => {

            },
            'froalaEditor.mouseup': (e, editor, mouseupEvent) => {

            }

          }
        }
        this.__oFroalaEditorOptionReadOnly = {
          key: data,
          attribution: false,
          heightMin: 250,
          heightMax: 500,
          width: 800,
          charCounterMax: 20000,
          charCounterCount: false,
          tableResizer: true,
          imageResize: true,
          useClasses: false,
          placeholderText: 'Enter Details ...',
          // Set the image upload parameter.
          imageUploadParam: 'image_param',
    
          // Set the image upload URL.
          imageUploadURL: 'assets/upload_image',
    
          // Additional upload params.
          imageUploadParams: { id: 'my_editor' },
    
          // Set request type.
          imageUploadMethod: 'POST',
    
          // Set max image size to 5MB.
          imageMaxSize: 5 * 1024 * 1024,
    
          // Allow to upload PNG and JPG.
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
          //toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'undo', 'redo'],
          //toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertFile', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'help', 'html', '|', 'undo', 'redo'],
          //pluginsEnabled: ['align', 'colors', 'draggable', 'fontFamily', 'fontSize', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'print', 'quote', 'image', 'table', 'specialCharacters', 'url', 'wordPaste'],
    
          toolbarButtons: [],
          pluginsEnabled: [],
    
          events: {
            'froalaEditor.initialized': function (e: any, editor: any) {
              editor.edit.off();
            },
            'froalaEditor.image.beforeUpload': (e: any, editor: any, images: any) => {
              //Your code 
              if (images.length) {
                // Create a File Reader.
                const reader = new FileReader();
                // Set the reader to insert images when they are loaded.
                reader.onload = (ev) => {
                  const result = ev.target['result'];
                  editor.image.insert(result, null, null, editor.image.get());
                };
                // Read image as base64.
                reader.readAsDataURL(images[0]);
              }
              // Stop default upload chain.
              return false;
            },
            'froalaEditor.mousedown': (e, editor, mousedownEvent) => {
    
            },
            'froalaEditor.mouseup': (e, editor, mouseupEvent) => {
    
            }
    
          }
        }
      }
    });
  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {
    this.onInitialized.emit(this);

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetRatingScoreCardRating").then((Data) => {

      if (Data != null) {
        let sRatings: string = Data;

        this.__oRatings = JSON.parse(sRatings);
      }

    });

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBaseCurrency").then((Data) => {

      if (Data != null) {
        this.__sBaseCurrency = Data;        
      }

    });

  }

  /// Events

  public TextAreaOnChange(e: any) {

    let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialId == e);

    if (oExistFAScoringModelFinancialView.IsScored == 1) {

      this.service.UpdateAllDataByPromise(oExistFAScoringModelFinancialView, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFinancialFactorScore").then(
        result => this.OnSuccessGetFAScoringModelFinancialForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelFinancial(error))
    }

  }

  public TextAreaOnChangeOriginal(e: any) {

    let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialId == e);

    oExistFAScoringModelFinancialView.AdjustedValue = oExistFAScoringModelFinancialView.OriginalValue;

    if (oExistFAScoringModelFinancialView.IsScored == 1) {

      this.service.UpdateAllDataByPromise(oExistFAScoringModelFinancialView, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFinancialFactorScore").then(
        result => this.OnSuccessGetFAScoringModelFinancialForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelFinancial(error))
    }

  }

  /// component public methods can be called from parent component

  public Refresh() {

    //console.log(this.__sInstanceId);
    //console.log(this.__sStateDataId);
    //console.log(this.__sValue);
    //console.log(this.__sDataCaption);
    this.__bIsLoadingVisible = true;

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceAllStateData/" + this.__sInstanceId).then((Data) => {

      if (Data != null) {

        let sData: string = Data;

        sData = sData.replace(/\n/g, 'neewwlliine').replace(/\r/g, 'neewwlliine');
        //sData = this.replaceAllSpecialCharacters(sData);

        try {
          this.__oInstanceAllStateData = JSON.parse(sData);

          for (let oFSV of this.__oInstanceAllStateData) {
            if (oFSV.DataValue != undefined || oFSV.DataValue != null)
              oFSV.DataValue = this.replaceAllSpecialCharacters(oFSV.DataValue);
          }​​​

          this.__sScoringModelName = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sScoringModel).DataValue;

          let oAPIParam: APIParam = new APIParam();
          oAPIParam.Param = this.__sScoringModelName;

          oAPIParam.sBaseYearPeriod = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sPeriod).DataValue;
          oAPIParam.sBasePeriod = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sBasePeriod).DataValue;
          oAPIParam.sTradingcounterparty = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sTradingCounterparty).DataValue;


          this.__sQualitativeValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sQualitativeControl).DataValue;
          this.__sQuantitativeValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sQuantitativeControl).DataValue;
          this.__sScoreAnalysisValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sScoreAnalysisControl).DataValue;

          if (!this.IsNullOrEmpty(this.__sFinalScoreControl) && (this.IsNullOrEmpty(this.__sValue) || this.__sValue == undefined)) {
            this.__sValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sFinalScoreControl).DataValue;
          }


          oAPIParam.sValue = "Plain";

          this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelFinalScoreView").then(
            result => this.OnSuccessGetFAScoringModelFinalScoreView(result, oAPIParam)
          ).
            catch(error => this.OnErrorGetFAScoringModelFinancial(error))

        }
        catch
        {
          console.log(sData);
          this.__bIsLoadingVisible = false;
        }

      }

    });



  }

  public OnSuccessGetFAScoringModelFinalScoreView(response: any, oAPIParam: APIParam) {

    if (response != null) {      
      let oFAScoringModelFinalScoreView: FAScoringModelFinalScoreView[] = response;

      for (let oFSV of oFAScoringModelFinalScoreView)
      {
        let sItemSource:string = oFSV.ItemSource;

        if (!this.IsNullOrUndefined(sItemSource) && !this.IsNullOrEmpty(sItemSource))
        {
          oFSV.JSONItemSource = JSON.parse(sItemSource);
        }
      }

      this.__oFAScoringModelFinalScoreView = oFAScoringModelFinalScoreView;


      if (!this.IsNullOrEmpty(this.__sValue))
      {
        let sXML: string = this.__sValue;

        sXML = sXML.replace('<FinalScoreAnalysis>', '');
        sXML = sXML.replace('</FinalScoreAnalysis>', '');

        let iDefinitionStartIndex: number = 0;
        let iDefinitionLastIndex: number = 0;
        let sColumnData: string = "";


        iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
        iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

        sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

        let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

        sXML = sXML.replace(sColumnData, '');

        if (sScoringModel == this.__sScoringModelName) {

          let oFinancialColumns: string[] = ['FARatingCategory', 'DataValue'];

          let iStartIndex: number = 0;
          let iLastIndex: number = 0;
          let sXMLData: string = '';
          let sNode: string = '';
          let iColumnStartIndex: number = 0;
          let iColumnLastIndex: number = 0;
          let sColumnValue: string = "";
          let sValue: any = "";
          let sData: string = '';

          let oFinancialFactors: any[] = [];

          while (sXML.trim() != '') {
            let oFinancialFactor: any = {};

            iStartIndex = sXML.indexOf("<Data>");
            iLastIndex = sXML.indexOf("</Data>");

            sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

            sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

            for (let oColumn of oFinancialColumns) {
              iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

              if (iColumnStartIndex >= 0) {
                iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

              }

              switch (oColumn) {
                case 'FARatingCategory':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.FARatingCategory = sValue;
                    }
                    break;
                  }
                case 'DataValue':
                  {
                    if (sValue != 'null' && sValue != 'undefined') {
                      oFinancialFactor.DataValue = sValue;
                    }
                    break;
                  }              

              }
            }

            sXML = sXML.replace(sXMLData, '');
            oFinancialFactors.push(oFinancialFactor);

          }


          for (let x of oFinancialFactors) {
            let oExistFSV: FAScoringModelFinalScoreView = this.__oFAScoringModelFinalScoreView.find(y => y.FARatingCategory == x.FARatingCategory);

            if (oFAScoringModelFinalScoreView != null) {

              if (oExistFSV.DataType == 'Numeric/Money')
                oExistFSV.DataValue = Number(x.DataValue);
              else {
                oExistFSV.DataValue = x.DataValue;

                if (this.IsNullOrUndefined(oExistFSV.DataValue)) { oExistFSV.DataValue = ''; }
              }

            }



          }

        }
      }
      if (this.IsNullOrEmpty(this.__sValue) && this.__bReadOnly == 0) { //FB 37696 - Vidya
        this.PopulateFinancialData(oAPIParam);
      }
    }

    
    this.__bIsLoadingVisible = false;
  }


  public PopulateFinancialData(oAPIParam: APIParam) {
    this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelFinancialView").then(
      result => this.OnSuccessGetFAScoringModelFinancial(result, oAPIParam)
    ).
      catch(error => this.OnErrorGetFAScoringModelFinancial(error))
  }

  public PopulateQualitativeData(oAPIParam: APIParam) {

    this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelQualitativeView").then(
      result => this.OnSuccessGetFAScoringModelQualitative(result)
    ).
      catch(error => this.OnErrorGetFAScoringModelQualitative(error))    

  }


  public GetData() {
    let sXML: string = '';

    sXML += '<FinalScoreAnalysis>';
    sXML += '<ScoringModel>' + this.__sScoringModelName + '</ScoringModel>';    

    for (let x of this.__oFAScoringModelFinalScoreView) {
      sXML += '<Data>';

      sXML += '<FARatingCategory>' + x.FARatingCategory + "</FARatingCategory>";
      sXML += '<DataValue>' + x.DataValue  + "</DataValue>";      

      sXML += '</Data>';
    }

    sXML += '</FinalScoreAnalysis>';
    return sXML;
  }

  public OnErrorGetFAScoringModelFinancial(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }
  public OnSuccessGetFAScoringModelFinancial(response: any, oAPIParam: APIParam) {

    if (response != null) {
      let oFAScoringModelFinancialView: FAScoringModelFinancialView[] = [];
      oFAScoringModelFinancialView = response;

      this.__oQuantitativeGroup = [];
      this.__oQuantitativeScoreCardGroup = [];

      for (let x of oFAScoringModelFinancialView) {


        for (let x of oFAScoringModelFinancialView) {
          if (!this.IsNullOrEmpty(x.FAScoreCardGroup)) {
            if (this.__oQuantitativeScoreCardGroup.find(y => y.GroupName == x.FAScoreCardGroup) == null) {
              let oFinancialGroup: QuantitativeGroup = new QuantitativeGroup();
              oFinancialGroup.GroupName = x.FAScoreCardGroup;
              this.__oQuantitativeScoreCardGroup.push(oFinancialGroup);
            }
          }



        }
      }

      this.__oFAScoringModelFinancialView = oFAScoringModelFinancialView;


      if (!this.IsNullOrEmpty(this.__sQuantitativeValue)) {
        let sXML: string = this.__sQuantitativeValue;

        sXML = sXML.replace('<FinancialData>', '');
        sXML = sXML.replace('</FinancialData>', '');

        let iDefinitionStartIndex: number = 0;
        let iDefinitionLastIndex: number = 0;
        let sColumnData: string = "";


        iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
        iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

        sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

        let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

        sXML = sXML.replace(sColumnData, '');

        if (sScoringModel == this.__sScoringModelName) {

          let oFinancialColumns: string[] = ['FinancialFactor', 'OriginalValue', 'AdjustedValue', 'Score', 'Weight', 'WeightedScore','GroupFormulaValue'];

          let iStartIndex: number = 0;
          let iLastIndex: number = 0;
          let sXMLData: string = '';
          let sNode: string = '';
          let iColumnStartIndex: number = 0;
          let iColumnLastIndex: number = 0;
          let sColumnValue: string = "";
          let sValue: any = "";
          let sData: string = '';

          let oFinancialFactors: any[] = [];

          while (sXML.trim() != '') {
            let oFinancialFactor: any = {};

            iStartIndex = sXML.indexOf("<Data>");
            iLastIndex = sXML.indexOf("</Data>");

            sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

            sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

            for (let oColumn of oFinancialColumns) {
              iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

              if (iColumnStartIndex >= 0) {
                iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

              }

              switch (oColumn) {
                case 'FinancialFactor':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.FinancialFactor = sValue;
                    }
                    break;
                  }
                case 'OriginalValue':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.OriginalValue = sValue;
                    }
                    break;
                  }
                case 'AdjustedValue':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.AdjustedValue = sValue;
                    }
                    break;
                  }
                case 'Score':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.Score = Number(sValue);
                    }
                    break;
                  }
                case 'Weight':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.Weight = Number(sValue);
                    }
                    break;
                  }
                case 'WeightedScore':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.WeightedScore = Number(sValue);
                    }
                    break;
                  }
                case 'GroupFormulaValue':
                  {
                    if (sValue != 'null') {
                      oFinancialFactor.GroupFormulaValue = Number(sValue);
                    }
                    break;
                  }

              }
            }

            sXML = sXML.replace(sXMLData, '');
            oFinancialFactors.push(oFinancialFactor);

          }


          for (let x of oFinancialFactors) {
            let oFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(y => y.lFAScoringModelFinancialViewId == x.FinancialFactor);

            if (oFAScoringModelFinancialView != null) {

              oFAScoringModelFinancialView.OriginalValue = x.OriginalValue;
              oFAScoringModelFinancialView.AdjustedValue = x.AdjustedValue;
              oFAScoringModelFinancialView.Score = x.Score;
              oFAScoringModelFinancialView.Weight = x.Weight;
              oFAScoringModelFinancialView.WeightedScore = x.WeightedScore;
              oFAScoringModelFinancialView.GroupFormulaValue = x.GroupFormulaValue;

            }



          }

        }

      }      


    }
    
    this.PopulateQualitativeData(oAPIParam);
    this.__bIsLoadingVisible = false;
  }

  public OnErrorGetFAScoringModelQualitative(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }
  public OnSuccessGetFAScoringModelQualitative(response: any) {

    if (response != null) {
      let oFAScoringModelQualitativeView: FAScoringModelQualitativeView[] = [];
      oFAScoringModelQualitativeView = response;


      this.__oFAScoringModelQualitativeView = oFAScoringModelQualitativeView;


      if (!this.IsNullOrEmpty(this.__sQualitativeValue)) {
        let sXML: string = this.__sQualitativeValue;

        sXML = sXML.replace('<QualitativeData>', '');
        sXML = sXML.replace('</QualitativeData>', '');

        let iDefinitionStartIndex: number = 0;
        let iDefinitionLastIndex: number = 0;
        let sColumnData: string = "";


        iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
        iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

        sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

        let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

        sXML = sXML.replace(sColumnData, '');

        if (sScoringModel == this.__sScoringModelName) {

          let oQualitativeColumns: string[] = ['QualitativeFactor', 'OriginalValue', 'AdjustedValue', 'Score', 'Weight', 'WeightedScore'];

          let iStartIndex: number = 0;
          let iLastIndex: number = 0;
          let sXMLData: string = '';
          let sNode: string = '';
          let iColumnStartIndex: number = 0;
          let iColumnLastIndex: number = 0;
          let sColumnValue: string = "";
          let sValue: any = "";
          let sData: string = '';

          let oQualitativeFactors: any[] = [];

          while (sXML.trim() != '') {
            let oQualitativeFactor: any = {};

            iStartIndex = sXML.indexOf("<Data>");
            iLastIndex = sXML.indexOf("</Data>");

            sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

            sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

            for (let oColumn of oQualitativeColumns) {
              iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

              if (iColumnStartIndex >= 0) {
                iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

              }

              switch (oColumn) {
                case 'QualitativeFactor':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.QualitativeFactor = sValue;
                    }
                    break;
                  }
                case 'OriginalValue':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.OriginalValue = sValue;
                    }
                    break;
                  }
                case 'AdjustedValue':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.AdjustedValue = sValue;
                    }
                    break;
                  }
                case 'Score':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.Score = Number(sValue);
                    }
                    break;
                  }
                case 'Weight':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.Weight = Number(sValue);
                    }
                    break;
                  }
                case 'WeightedScore':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.WeightedScore = Number(sValue);
                    }
                    break;
                  }

              }
            }

            sXML = sXML.replace(sXMLData, '');
            oQualitativeFactors.push(oQualitativeFactor);

          }


          for (let x of oQualitativeFactors) {
            let oFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(y => y.QualitativeFactor == x.QualitativeFactor);

            if (oFAScoringModelQualitativeView != null) {

              oFAScoringModelQualitativeView.OriginalValue = x.OriginalValue;
              oFAScoringModelQualitativeView.AdjustedValue = x.AdjustedValue;
              oFAScoringModelQualitativeView.Score = x.Score;
              oFAScoringModelQualitativeView.Weight = x.Weight;
              oFAScoringModelQualitativeView.WeightedScore = x.WeightedScore;


            }


          }

        }

      }      

    }
    this.PopulateScoreAnalysisData();
    this.__bIsLoadingVisible = false;
  }

  public OnErrorCalculateQualitativeWeightedScoreRating(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessCalculateQualitativeWeightedScoreRating(response: any) {

    if (response != null) {
      let oResponse: QualitativeWeightedScoreResponse = response;

      this.__sWeightedQualitativeRating = oResponse.Rating;
      this.__iWeightedQualitativeScore = oResponse.Score;

      this.CalculateIntrinsicScoreRating();
    }
    this.__bIsLoadingVisible = false;
  }


  public OnErrorGetScoreCardGroupScoreAnalysis(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetScoreCardGroupScoreAnalysis(response: any) {

    if (response != null) {
      let oResponse: ScoreCardGroupScoreAnalysis[] = response;


      for (let oScoreAnalysis of oResponse) {
        let oExistSA: ScoreCardGroupScoreAnalysis = this.__oFAScoreCardGroupScoreAnalysis.find(x => x.Id == oScoreAnalysis.Id);

        oExistSA.Rating = oScoreAnalysis.Rating;
        oExistSA.Score = oScoreAnalysis.Score;
        oExistSA.WeightedScore = oScoreAnalysis.WeightedScore;
        oExistSA.WeightedScoreDummy = oScoreAnalysis.Score;
      }

      this.CalculateWeightedFinancialRating()

    }
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetFAScoringModelFinancialForNewScore(response: any) {

    if (response != null) {
      let oFAScoringModelFinancialView: FAScoringModelFinancialView = response;

      let oExistFAScoringModelFinancialView: FAScoringModelFinancialView = this.__oFAScoringModelFinancialView.find(x => x.lFAScoringModelFinancialId == oFAScoringModelFinancialView.lFAScoringModelFinancialId);

      if (!this.IsNullOrUndefined(oExistFAScoringModelFinancialView)) {
        oExistFAScoringModelFinancialView.Score = oFAScoringModelFinancialView.Score;
        oExistFAScoringModelFinancialView.WeightedScore = oExistFAScoringModelFinancialView.Score * oExistFAScoringModelFinancialView.Weight;
      }

    }
    this.__bIsLoadingVisible = false;
  }

  public SliderValueChanged(e: any) {
    this.__bIsLoadingVisible = true;
    let oScoreCardGroupScoreAnalysis: ScoreCardGroupScoreAnalysis = this.__oFAScoreCardGroupScoreAnalysis.find(x => x.Id == e);
    oScoreCardGroupScoreAnalysis.WeightedScore = oScoreCardGroupScoreAnalysis.WeightGuage * oScoreCardGroupScoreAnalysis.WeightedScoreDummy / 100;
    this.CalculateTotalWeightGauge();
    this.CalculateWeightedFinancialRating();
    this.__bIsLoadingVisible = false;

  }

  public CalculateTotalWeightGauge() {
    this.__iTotalWeightGauge = 0;
    for (let x of this.__oFAScoreCardGroupScoreAnalysis) {
      this.__iTotalWeightGauge = this.__iTotalWeightGauge + x.WeightGuage;
    }
  }

  public CalculateWeightedFinancialRating() {
    this.__iWeightedFinancialScore = 0;
    for (let x of this.__oFAScoreCardGroupScoreAnalysis) {
      this.__iWeightedFinancialScore = this.__iWeightedFinancialScore + x.WeightedScore;
    }

    let oAPIParamSA: APIParamSA = new APIParamSA();
    oAPIParamSA.WeightedScore = this.__iWeightedFinancialScore;
    oAPIParamSA.sParam = this.__sScoringModelName;

    this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateWeightedFinancialRating").then(
      result => this.OnSuccessGetCalculateWeightedFinancialRating(result)
    ).
      catch(error => this.OnErrorCalculateWeightedFinancialRating(error))
  }


  public OnErrorCalculateWeightedFinancialRating(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetCalculateWeightedFinancialRating(response: any) {

    if (response != null) {
      let oResponse: string = response;

      this.__sWeightedFinancialRating = oResponse;

      this.CalculateIntrinsicScoreRating();


    }
    this.__bIsLoadingVisible = false;
  }

  public CalculateIntrinsicScoreRating() {

    // calculate intrinsic rating

    let oAPIParamSA: APIParamSA = new APIParamSA();
    oAPIParamSA.sParam = this.__sScoringModelName;

    let oIndexWithScore: FinancialIndexWithScore[] = [];

    for (let oGroupFactor of this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup != null && x.Score != null && x.Weight != null)) {
      var regexScore: RegExp = new RegExp(oGroupFactor.ScoreIndex, "g");
      var regexWeight: RegExp = new RegExp(oGroupFactor.WeightIndex, "g");

      let oFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithScore.Index = oGroupFactor.ScoreIndex;
      oFinancialIndexWithScore.Score = oGroupFactor.Score;

      oIndexWithScore.push(oFinancialIndexWithScore);

      let oFinancialIndexWithWeight: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithWeight.Index = oGroupFactor.WeightIndex;
      oFinancialIndexWithWeight.Score = oGroupFactor.Weight;

      oIndexWithScore.push(oFinancialIndexWithWeight);
    }

    // Weighted financial rating

    let oWeightedFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oWeightedFinancialIndexWithScore.Index = 'WGFR';
    oWeightedFinancialIndexWithScore.Score = this.__iWeightedFinancialScore;

    oIndexWithScore.push(oWeightedFinancialIndexWithScore);

    let oWeightedQualitativeIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oWeightedQualitativeIndexWithScore.Index = 'QF';
    oWeightedQualitativeIndexWithScore.Score = this.__iWeightedQualitativeScore;

    oIndexWithScore.push(oWeightedQualitativeIndexWithScore);


    oAPIParamSA.FinancialIndexWithScore = oIndexWithScore;

    this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateIntrinsicScoreRating").then(
      result => this.OnSuccessGetCalculateIntrinsicScoreRating(result)
    ).
      catch(error => this.OnErrorCalculateIntrinsicScoreRating(error))
  }

  public OnErrorCalculateIntrinsicScoreRating(error: any) {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetCalculateIntrinsicScoreRating(response: any) {

    if (response != null) {
      let oResponse: QualitativeWeightedScoreResponse = response;

      this.__sWeightedIntrinsicRating = oResponse.Rating;
      this.__iWeightedIntrinsicScore = oResponse.Score;

    }
    this.__bIsLoadingVisible = false;
  }

  public PopulateScoreAnalysisData() {
    if (!this.IsNullOrEmpty(this.__sScoreAnalysisValue)) {
      let sXML: string = this.__sScoreAnalysisValue;

      sXML = sXML.replace('<ScoreAnalysis>', '');
      sXML = sXML.replace('</ScoreAnalysis>', '');

      let iDefinitionStartIndex: number = 0;
      let iDefinitionLastIndex: number = 0;
      let sColumnData: string = "";


      iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
      iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

      let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

      sXML = sXML.replace(sColumnData, '');

      // financial rating

      iDefinitionStartIndex = sXML.indexOf("<WeightedFinancialRating>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedFinancialRating>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 26);

      this.__sWeightedFinancialRating = sColumnData.replace("<WeightedFinancialRating>", "").replace("</WeightedFinancialRating>", "");

      sXML = sXML.replace(sColumnData, '');

      // financial score

      iDefinitionStartIndex = sXML.indexOf("<WeightedFinancialScore>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedFinancialScore>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 25);

      this.__iWeightedFinancialScore = Number(sColumnData.replace("<WeightedFinancialScore>", "").replace("</WeightedFinancialScore>", ""));

      sXML = sXML.replace(sColumnData, '');
      // qualitative rating

      iDefinitionStartIndex = sXML.indexOf("<WeightedQualitativeRating>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedQualitativeRating>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 28);

      this.__sWeightedQualitativeRating = sColumnData.replace("<WeightedQualitativeRating>", "").replace("</WeightedQualitativeRating>", "");

      sXML = sXML.replace(sColumnData, '');

      // qualitative score

      iDefinitionStartIndex = sXML.indexOf("<WeightedQualitativeScore>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedQualitativeScore>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 27);

      this.__iWeightedQualitativeScore = Number(sColumnData.replace("<WeightedQualitativeScore>", "").replace("</WeightedQualitativeScore>", ""));

      sXML = sXML.replace(sColumnData, '');
      // intrinsic rating

      iDefinitionStartIndex = sXML.indexOf("<WeightedIntrinsicRating>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedIntrinsicRating>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 26);

      this.__sWeightedIntrinsicRating = sColumnData.replace("<WeightedIntrinsicRating>", "").replace("</WeightedIntrinsicRating>", "");

      sXML = sXML.replace(sColumnData, '');

      // intrinsic score

      iDefinitionStartIndex = sXML.indexOf("<WeightedIntrinsicScore>");
      iDefinitionLastIndex = sXML.indexOf("</WeightedIntrinsicScore>");

      sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 25);

      this.__iWeightedIntrinsicScore = Number(sColumnData.replace("<WeightedIntrinsicScore>", "").replace("</WeightedIntrinsicScore>", ""));

      sXML = sXML.replace(sColumnData, '');

      if (sScoringModel == this.__sScoringModelName) {

        let oFinancialColumns: string[] = ['Id', 'ScoreCardGroup', 'Score', 'Rating', 'WeightGuage', 'WeightedScore', 'WeightedScoreDummy', 'Formula'];

        let iStartIndex: number = 0;
        let iLastIndex: number = 0;
        let sXMLData: string = '';
        let sNode: string = '';
        let iColumnStartIndex: number = 0;
        let iColumnLastIndex: number = 0;
        let sColumnValue: string = "";
        let sValue: any = "";
        let sData: string = '';

        let oFinancialFactors: any[] = [];

        while (sXML.trim() != '') {
          let oFinancialFactor: any = {};

          iStartIndex = sXML.indexOf("<Data>");
          iLastIndex = sXML.indexOf("</Data>");

          sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

          sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

          for (let oColumn of oFinancialColumns) {
            iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

            if (iColumnStartIndex >= 0) {
              iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

              sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

              sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

            }

            switch (oColumn) {
              case 'Id':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Id = Number(sValue);
                  }
                  break;
                }
              case 'ScoreCardGroup':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.ScoreCardGroup = sValue;
                  }
                  break;
                }
              case 'Score':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Score = Number(sValue);
                  }
                  break;
                }
              case 'Rating':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Rating = sValue;
                  }
                  break;
                }
              case 'WeightGuage':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.WeightGuage = Number(sValue);
                  }
                  break;
                }
              case 'WeightedScore':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.WeightedScore = Number(sValue);
                  }
                  break;
                }
              case 'WeightedScoreDummy':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.WeightedScoreDummy = Number(sValue);
                  }
                  break;
                }
              case 'Formula':
                {
                  if (sValue != 'null') {
                    oFinancialFactor.Formula = sValue;
                  }
                  break;
                }

            }
          }

          sXML = sXML.replace(sXMLData, '');
          oFinancialFactors.push(oFinancialFactor);

        }

        this.__oFAScoreCardGroupScoreAnalysis = [];

        for (let x of oFinancialFactors) {
          let oFAScoringModelFinancialView: ScoreCardGroupScoreAnalysis = new ScoreCardGroupScoreAnalysis();

          oFAScoringModelFinancialView.Id = x.Id;
          oFAScoringModelFinancialView.Score = x.Score;
          oFAScoringModelFinancialView.Rating = x.Rating;
          oFAScoringModelFinancialView.WeightGuage = x.WeightGuage;
          oFAScoringModelFinancialView.WeightedScore = x.WeightedScore;
          oFAScoringModelFinancialView.Formula = x.Formula;
          oFAScoringModelFinancialView.WeightedScoreDummy = x.Score;
          oFAScoringModelFinancialView.ScoreCardGroup = x.ScoreCardGroup;

          this.__oFAScoreCardGroupScoreAnalysis.push(oFAScoringModelFinancialView);

        }

      }

    }

    this.PopulateFinalSummary();
  }


  public PopulateFinalSummary()
  {

    let oAPIParamSA: APIParamSA = new APIParamSA();

    oAPIParamSA.FAScoringModelFinalScoreView = this.__oFAScoringModelFinalScoreView;

    let oIndexWithScore: FinancialIndexWithScore[] = [];

    for (let oGroupFactor of this.__oFAScoringModelFinancialView.filter(x => x.FAScoreCardGroup != null && x.Score != null && x.Weight != null)) {      

      let oFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithScore.Index = oGroupFactor.ScoreIndex;
      oFinancialIndexWithScore.Score = oGroupFactor.Score;

      oIndexWithScore.push(oFinancialIndexWithScore);

      let oFinancialIndexWithWeight: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithWeight.Index = oGroupFactor.WeightIndex;
      oFinancialIndexWithWeight.Score = oGroupFactor.Weight;

      oIndexWithScore.push(oFinancialIndexWithWeight);

      let oFinancialIndexWithWeightGFV: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithWeightGFV.Index = oGroupFactor.GroupFormulaIndex;
      oFinancialIndexWithWeightGFV.Score = oGroupFactor.GroupFormulaValue;

      oIndexWithScore.push(oFinancialIndexWithWeightGFV);
    }

    for (let oGroupFactor of this.__oFAScoringModelQualitativeView.filter(x => x.lFAScoreCardId != null && x.Score != null && x.Weight != null)) {

      let oFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithScore.Index = oGroupFactor.ScoreIndex;
      oFinancialIndexWithScore.Score = oGroupFactor.Score;

      oIndexWithScore.push(oFinancialIndexWithScore);

      let oFinancialIndexWithWeight: FinancialIndexWithScore = new FinancialIndexWithScore();
      oFinancialIndexWithWeight.Index = oGroupFactor.WeightIndex;
      oFinancialIndexWithWeight.Score = oGroupFactor.Weight;

      oIndexWithScore.push(oFinancialIndexWithWeight);
     
    }

    // Weighted financial rating

    let oWeightedFinancialIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oWeightedFinancialIndexWithScore.Index = 'WGFR';
    oWeightedFinancialIndexWithScore.Score = this.__iWeightedFinancialScore;

    oIndexWithScore.push(oWeightedFinancialIndexWithScore);

    let oWeightedQualitativeIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oWeightedQualitativeIndexWithScore.Index = 'QF';
    oWeightedQualitativeIndexWithScore.Score = this.__iWeightedQualitativeScore;

    oIndexWithScore.push(oWeightedQualitativeIndexWithScore);


    let oIntrinsicIndexWithScore: FinancialIndexWithScore = new FinancialIndexWithScore();
    oIntrinsicIndexWithScore.Index = 'INTR';
    oIntrinsicIndexWithScore.Score = this.__iWeightedIntrinsicScore;

    oIndexWithScore.push(oIntrinsicIndexWithScore);

    /// Rating

    let oIndexWithRating: FinancialIndexWithRating[] = [];

    let oWGFR: FinancialIndexWithRating = new FinancialIndexWithRating();
    oWGFR.Index = 'WGFR';
    oWGFR.Rating = this.__sWeightedFinancialRating;

    oIndexWithRating.push(oWGFR);

    let oQF: FinancialIndexWithRating = new FinancialIndexWithRating();
    oQF.Index = 'QF';
    oQF.Rating = this.__sWeightedQualitativeRating;

    oIndexWithRating.push(oQF);

    let oINTR: FinancialIndexWithRating = new FinancialIndexWithRating();
    oINTR.Index = 'INTR';
    oINTR.Rating = this.__sWeightedIntrinsicRating;

    oIndexWithRating.push(oINTR);


    oAPIParamSA.FinancialIndexWithScore = oIndexWithScore;
    oAPIParamSA.FinancialIndexWithRating = oIndexWithRating;

    this.service.UpdateAllDataByPromise(oAPIParamSA, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateFAScoringModelFinalScore").then(
      result => this.OnSuccessGetCalculateFAScoringModelFinalScore(result)
    ).
      catch(error => this.OnErrorGetFAScoringModelFinancial(error))
  }


  public OnSuccessGetCalculateFAScoringModelFinalScore(response: any) {

    if (response != null) {
      let oResponse: FAScoringModelFinalScoreView[] = response;

      for (let oFSV of oResponse) {
        let oExistFSV: FAScoringModelFinalScoreView = this.__oFAScoringModelFinalScoreView.find(x => x.lFAScoringModelFinalScoreId == oFSV.lFAScoringModelFinalScoreId);

        if (oExistFSV.DataType == 'Numeric/Money')
          oExistFSV.DataValue = Number(oFSV.DataValue);
        else {
          oExistFSV.DataValue = oFSV.DataValue;

          if (this.IsNullOrUndefined(oExistFSV.DataValue)) { oExistFSV.DataValue = '';}
        }


        


      }

    }
    this.__bIsLoadingVisible = false;
  }

  onKeyPressNumberBox(e: any,Item:any) {    

    //if (BusinessProcessInstanceCurrentStateData.DataValue != null && BusinessProcessInstanceCurrentStateData.DataValue != undefined) {
    if (e.event.key == 'm' || e.event.key == "M") {
      Item.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
    }
    else if (e.event.key == "b" || e.event.key == "B") {
      Item.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
    }
    else if (e.event.key == "k" || e.event.key == "K") {
      Item.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
    }
    else if (e.event.key == "h" || e.event.key == "H") {
      Item.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
    }
    else if (e.event.key == "t" || e.event.key == "T") {
      Item.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
    }
    //}

    //e.component.focus();

  }

  public replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  public replaceFilePath(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/\\/g, 'bckwrdslsh101').replace(/:/g, 'cln100');
    return strToBeReturned;
  }

  public URLEncode(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/&/g, '%26');
    return strToBeReturned;
  }



  public IsNullOrEmpty(sValue: string) {
    if (sValue == undefined || sValue == '' || sValue == null || sValue.trim() == '') {
      return true;
    }
    else {
      return false;
    }
  }

  public IsNullOrUndefined(iValue: any) {
    if (iValue == undefined || iValue == null) {
      return true;
    }
    else {
      return false;
    }
  }

  public IsTrue(oValue: any) {
    if (oValue != undefined && (oValue == 1 || oValue.toString() == 'true')) {
      return true;
    }
    else {
      return false;
    }
  }

  public format(value) {
    return value + "%";
  }

  private replaceAllSpecialCharacters(str: any) {
    let strToBeReturned = "";

    strToBeReturned = str.replace(/backslaaash/g, "\\\\").replace(/annnd/g, "&").replace(/pluuuus/g, "+").replace(/cln100/g, ":").replace(/leeesthan/g, "<").replace(/greeeterthan/g, ">").replace(/hassh/g, "#")
      .replace(/aaat/g, "@").replace(/staaar/g, "*").replace(/dolllaar/g, "$").replace(/perseent/g, "%").replace(/exclammmaation/g, "!").replace(/quoootes/g, '"').replace(/ampersand/g, "&"); //FB 30669 - Vidya

    return strToBeReturned;
  }

}
